/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I convert minutes into hours and minutes (like 150 minutes into 2h 30m)?`)
};

const es_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo convierto minutos en horas y minutos (como 150 minutos en 2h 30m)?`)
};

const de_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie rechne ich Minuten in Stunden und Minuten um (z. B. 150 Minuten in 2h 30m)?`)
};

const nl_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe converteer ik minuten in uren en minuten (zoals 150 minuten in 2u 30m)?`)
};

const fr_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment convertir les minutes en heures et minutes (comme 150 minutes en 2h 30m) ?`)
};

const it_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come converto i minuti in ore e minuti (come 150 minuti in 2h 30m)?`)
};

const pt_br2_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço para converter minutos em horas e minutos (como 150 minutos em 2h 30m)?`)
};

const pt_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço conversão de minutos em horas e minutos (como 150 minutos em 2h 30m)?`)
};

const ja_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分を時間と分に変換する(150分を2時間30分に変換するなど)にはどうすればよいですか?`)
};

const zh_uc_time_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq4_q", locale)
	if (locale === "en") return en_uc_time_faq4_q(inputs)
	if (locale === "es") return es_uc_time_faq4_q(inputs)
	if (locale === "de") return de_uc_time_faq4_q(inputs)
	if (locale === "nl") return nl_uc_time_faq4_q(inputs)
	if (locale === "fr") return fr_uc_time_faq4_q(inputs)
	if (locale === "it") return it_uc_time_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq4_q(inputs)
	if (locale === "pt") return pt_uc_time_faq4_q(inputs)
	if (locale === "ja") return ja_uc_time_faq4_q(inputs)
	return zh_uc_time_faq4_q(inputs)
};